// -- [Reusable Drivible logo component]

import { useState } from 'react'

// -- Same phrase as the logo image title tooltip
export const BRAND_TAGLINE = 'Document Storage and Management for Aussie Car Dealerships'

interface LogoProps {
  variant: 'light' | 'dark'
  src?: string
  className?: string
}

export function Logo({ variant, src, className = '' }: LogoProps) {
  const [errored, setErrored] = useState(false)
  const defaultSrc = variant === 'light' ? '/logos/drivible-white.svg' : '/logos/drivible-black.svg'
  const imgSrc = src ?? defaultSrc

  if (errored) {
    return (
      <span
        className={`font-semibold text-xl ${variant === 'light' ? 'text-white' : 'text-black'} ${className}`}
        title={BRAND_TAGLINE}
      >
        drivible
      </span>
    )
  }

  return (
    <img
      src={imgSrc}
      alt="Drivible"
      width={128}
      height={32}
      className={`h-8 object-contain ${className}`}
      onError={() => setErrored(true)}
      title={BRAND_TAGLINE}
    />
  )
}
